// SCAFFOLDED BY g8 — edit directly or run `g8 create --regen` to regenerate.
import React from "react";
import { SectionRenderer, registerServiceSections } from "@repo/features/site";
import { useClientConfig } from "@repo/backend/providers";
import { HeroKinetic } from "../components/HeroKinetic.js";
import { MarqueeKinetic } from "../components/MarqueeKinetic.js";
import { TrustBadges } from "../components/TrustBadges.js";
import { QuoteCalculator } from "../components/QuoteCalculator.js";
import { ServiceAreaMap } from "../components/ServiceAreaMap.js";
import { FaqAccordion } from "../components/FaqAccordion.js";
import { FooterRace } from "../components/FooterRace.js";

registerServiceSections();

// Section layout is hardcoded at scaffold time — edit here or regenerate.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const SECTIONS: any[] = [
  {
    "id": "story-0",
    "type": "story",
    "variant": "story-testimonial",
    "props": {
      "headline": "Trusted by Car Enthusiasts",
      "body": "We've detailed over 2,500 vehicles with a 98% satisfaction rate. Our mobile service means zero hassle — we come to you, fully equipped, every time.",
      "quote": "Noah did an amazing job! It was back to the day I drove it off the lot — it felt brand new! I had to ship my car and get it all cleaned out including getting every strand of pet hair out. The process was easy, I was able to get an appointment pretty quickly, and pricing wasn't too bad for what was needed. Oh and when it came to shipping day — ended up being the easiest part of the move. If you want your car back to factory settings just like when you first bought it, I highly recommend Bizzy Details!",
      "attribution": "Laura Wehunt",
      "role": "Verified Customer"
    },
    "animation": {
      "preset": "slide-left"
    }
  },
  {
    "id": "services-0",
    "type": "services",
    "variant": "services-numbered",
    "props": {
      "headline": "Get Started.",
      "subheadline": "High-impact solutions for machines that demand nothing but the best.",
      "services": [
        {
          "name": "Standard Detail",
          "description": "Our Standard Detail provides a complete interior and exterior cleaning to restore your vehicle's shine and freshness. It's the perfect choice for routine maintenance and keeping your car looking its best.",
          "eyebrow": "Interior + Exterior",
          "priceLabel": "From $189"
        },
        {
          "name": "Deluxe Detail",
          "description": "Our Deluxe Detail goes beyond the basics with a deep interior cleaning and enhanced exterior protection for a like-new finish. It's ideal for vehicles that need extra care and attention.",
          "eyebrow": "Deep Clean",
          "priceLabel": "From $248"
        },
        {
          "name": "Factory Detail",
          "description": "Our Factory Detail is our most comprehensive package, delivering a top-to-bottom restoration for a true showroom-quality appearance. Every surface is meticulously cleaned, conditioned, and protected using professional-grade products.",
          "eyebrow": "Full Restoration",
          "priceLabel": "From $379"
        },
        {
          "name": "Ceramic Coating",
          "description": "Our professional ceramic coating provides years of durable protection against UV rays, dirt, water, and environmental contaminants. It enhances your vehicle's gloss while making it easier to keep clean and maintain. Paint correction included.",
          "eyebrow": "5-Year Protection",
          "priceLabel": "From $889"
        }
      ],
      "ctaLabel": "Book Your Service",
      "ctaTarget": "#quote"
    },
    "animation": {
      "preset": "stagger-children",
      "stagger": 0.1
    }
  },
  {
    "id": "before-after-0",
    "type": "gallery",
    "variant": "before-after",
    "props": {
      "headline": "Garage Hall of Fame",
      "subheadline": "Click any card to compare before & after with our interactive slider.",
      "pairs": [
        {
          "beforeUrl": "/before1.jpeg",
          "afterUrl": "/after1.jpeg",
          "beforeAlt": "BMW wheel with brake dust and grime",
          "afterAlt": "BMW wheel polished and restored",
          "caption": "Wheel detail — brake dust removal & polish"
        },
        {
          "beforeUrl": "/before2.png",
          "afterUrl": "/after2.png",
          "beforeAlt": "Interior dirty and dusty",
          "afterAlt": "Interior fully restored and clean",
          "caption": "Interior deep clean — full cabin restoration"
        },
        {
          "beforeUrl": "/before3.jpeg",
          "afterUrl": "/after3.jpeg",
          "beforeAlt": "Leather armrest dull and worn",
          "afterAlt": "Leather armrest conditioned and bright",
          "caption": "Leather conditioning — armrest restoration"
        }
      ],
    },
    "animation": {
      "preset": "fade-up"
    }
  },
];

export function HomePage() {
  const config = useClientConfig();
  return (
    <main style={{ overflowX: "hidden" }}>
      <HeroKinetic />
      <MarqueeKinetic />
      <SectionRenderer
        sections={SECTIONS}
        clientId="bizzydetails"
        features={config.features}
      />
      <QuoteCalculator />
      <ServiceAreaMap />
      <FaqAccordion />
      <TrustBadges />
      <FooterRace />
    </main>
  );
}
